import * as React from 'react';


export default function CoreAPI() {


    return (
        <div>
            <p>Core API</p>
        </div>
    );
}
